var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(`${_vm.tab}View`, {
    tag: "component",
    attrs: {
      tabSelected: _vm.tab,
      defaultDate: _vm.date,
      scrollToHour: _vm.scrollToHour,
      defaultSelectedPost: _vm.defaultSelectedPost,
      autoValidatePostSelected:
        _vm.validate_post === "true" || _vm.validate_post === true,
      autoEditPostSelected: _vm.edit_post === "true" || _vm.edit_post === true,
    },
    on: { changeTab: _vm.changeTab },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }